<div class="full-screen-payment-container">
  <div class="payment-content">
    <h3 class="text-center" *ngIf="paymentStatus === 'PROCESSING'">
      Processing {{ amount | currency:currency }}{{ savedCardId ? ' on the saved card.' : ' on the PayBright terminal.' }}
    </h3>
    <h3 class="text-center" *ngIf="paymentStatus === 'APPROVED'">
      Payment approved!
    </h3>
    <h3 class="text-center" *ngIf="paymentStatus === 'DECLINED'">
      Card declined
    </h3>
    <h3 class="text-center" *ngIf="paymentStatus === 'ERROR'">
      Payment could not be processed
    </h3>

    <mat-progress-bar mode="indeterminate" [class.invisible]="!isProcessing"></mat-progress-bar>

    <div *ngIf="paymentStatus" class="payment-status mt-3"
         [ngClass]="{
           'text-success': paymentStatus === 'APPROVED',
           'text-info': paymentStatus === 'PROCESSING',
           'text-warning': paymentStatus === 'DECLINED',
           'text-danger': paymentStatus === 'ERROR'
         }">
      <mat-icon>
        {{ paymentStatus === 'APPROVED' ? 'check_circle' :
           paymentStatus === 'PROCESSING' ? 'point_of_sale' :
           paymentStatus === 'DECLINED' ? 'credit_card_off' : 'error' }}
      </mat-icon>
      {{ paymentStatusMessage }}
    </div>

    <div *ngIf="gatewayErrorCode" class="text-muted small mt-1">
      Gateway error code: {{ gatewayErrorCode }}
    </div>

    <div *ngIf="referenceNumber" class="checkout-id mt-2">
      Reference: {{ referenceNumber }}
    </div>

    <div *ngIf="amount" class="amount-display mt-2">
      Amount: {{ amount | currency:currency:'symbol':'1.2-2' }}
    </div>

    <button mat-raised-button
            color="warn"
            (click)="onCancelPaymentClick()"
            [disabled]="isCancelling"
            *ngIf="paymentStatus === 'PROCESSING' && !savedCardId"
            type="button">
      <mat-icon>cancel</mat-icon>
      Cancel
    </button>

    <button mat-raised-button
            color="primary"
            (click)="onRetryClick()"
            [disabled]="isProcessing"
            *ngIf="paymentStatus === 'DECLINED' || paymentStatus === 'ERROR'"
            type="button">
      <mat-icon>refresh</mat-icon>
      Try Again
    </button>

    <button mat-raised-button
            color="warn"
            (click)="onCancel()"
            *ngIf="paymentStatus === 'DECLINED' || paymentStatus === 'ERROR'"
            type="button">
      <mat-icon>arrow_back</mat-icon>
      Go Back
    </button>
  </div>
</div>
